import * as SG from '../style/Styles'
import * as U from './../util/UrlHttp'

export default function Footer() {

  return (
    <SG.Footer className='footer'>
      <SG.LogoKnauf src={U.LOGO_KNAUF2} alt="Knauf Footer"/>
    </SG.Footer>
  );
}
  